import { FacultyService } from 'src/app/Services/faculty.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/Services/auth.service';
import { HodService } from 'src/app/Services/hod.service';
import { RegisterService } from 'src/app/Services/register.service';
import { TokenService } from 'src/app/Services/token.service';
import { emailValidator } from 'src/app/theme/utils/app-validators';
import { EmailVerificationPopupComponent } from '../register/email-verification-popup/email-verification-popup.component';
import { MatDialog } from '@angular/material/dialog';
import * as shajs from 'sha.js';

@Component({
  selector: 'app-faculty-register',
  templateUrl: './faculty-register.component.html',
  styleUrls: ['./faculty-register.component.scss']
})
export class FacultyRegisterComponent implements OnInit {

  registerFacultyForm: FormGroup;
  email: any;
  error: any;

  constructor(public dialog: MatDialog,
    private token: TokenService,
    private auth: AuthService,
    private toastr: ToastrService,
    public fb: FormBuilder,
    public router: Router,
    private facultyService: FacultyService,
    private registerService: RegisterService) { }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.registerFacultyForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      email: [null, Validators.compose([Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$')])],
      mobile: ['', [Validators.required, Validators.pattern('[6789][0-9]{9}')]],
      password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      confirmPassword: [null, Validators.compose([Validators.required, Validators.pattern('(?=^.{6,}$)(?=.*[0-9])(?![.\n])(?=.*[@!#$%^&*-+:;_=,.<>~`/()\\[\\{}])(?=.*[A-Z])(?=.*[a-z]).*$')])],
      role_id: ''
    })
  }

  getDetails() {
    this.email = this.registerFacultyForm.get('email').value;
    let encryptedEmail = btoa(this.registerFacultyForm.get('email').value);
    this.facultyService.getFacultyRegDetails(encryptedEmail).subscribe(response => {
      if (response['type'] == "Error") {
        this.toastr.error(response['message'])
      }
      if (response['type'] == "Success") {
        this.registerFacultyForm.controls.name.setValue(response['facultyRegDetails']['FIRST_NAME'] + ' ' + response['facultyRegDetails']['SURNAME']);
        this.registerFacultyForm.controls.mobile.setValue(response['facultyRegDetails']['MOBILEPHONE_NUM']);
        this.registerFacultyForm.controls.role_id.setValue(8);
      }
    })
  }

  onSubmit() {

    if (this.registerFacultyForm.valid) {
      if (this.registerFacultyForm.value.password == this.registerFacultyForm.value.confirmPassword) {
        let tempEmail = this.registerFacultyForm.controls.email.value;
        let lowerCaseEmail = tempEmail.toLowerCase();
        let encryptedEmail = btoa(lowerCaseEmail);
        // let encryptedEmail = btoa(this.registerFacultyForm.controls.email.value);
        let encryptedPassword = shajs('sha512').update(this.registerFacultyForm.controls.password.value + encryptedEmail).digest('hex');
        this.registerFacultyForm.value.password = encryptedPassword;
        this.registerFacultyForm.value.confirmPassword = shajs('sha512').update(this.registerFacultyForm.controls.confirmPassword.value + encryptedEmail).digest('hex');;
        this.registerFacultyForm.value.email = encryptedEmail;
        this.registerService.submitRegistration(this.registerFacultyForm.value).subscribe(
          response => this.handleResponse(response),
          error => this.handleError(error)
        )
      } else {
        this.toastr.error('Password confirmation does not match!');
      }
    } else {
      this.showError('Kindly fill all the details')
    }
  }

  // for toastr
  showSuccess(message: string) {
    this.toastr.success(message, 'Success');
  }
  showError(message: string) {
    this.toastr.error(message, 'Error!');
  }
  showWarning(message: string) {
    this.toastr.warning(message, 'Warning');
  }
  showInfo(message: string) {
    this.toastr.info(message, 'Info');
  }

  isSpace(evt) {
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode == 32) {
      return false;
    }
    return true;
  }

  handleResponse(data) {
    if (data['type'] == 'Success') {
      this.verifyEmailPopup();
    }
    else {
      this.toastr.error(data['message']);
    }
  }

  handleError(error) {
    this.error = error.error.errors;
    this.showError(error.error.errors);
  }

  verifyEmailPopup() {
    const dialogRef = this.dialog.open(EmailVerificationPopupComponent);
    dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit()
    });
  }

}
